import { useTheme } from "@/theme/ThemeProvider";
import { ActivityIndicator, Platform, StyleSheet, Text, View } from "react-native";

/** Weiterleitung entscheidet ausschließlich das Root-Layout. */
export default function Index() {
  const { theme } = useTheme();
  return (
    <View
      style={[
        styles.loading,
        { backgroundColor: theme.color.bg },
        Platform.OS === "web" && styles.loadingWeb,
      ]}
      {...(Platform.OS === "web" ? { dataSet: { fcShell: "1" } } : {})}
    >
      <ActivityIndicator size="large" color={theme.color.primary} />
      <Text style={[styles.loadingText, { color: theme.color.text }]}>Laden…</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  loading: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
  },
  loadingWeb: {
    minHeight: "100vh" as unknown as number,
  },
});
